<div *ngIf="loaded==1">

    <h6 class="h6Title">Informacion del curso</h6>
    <hr>

    <form>

        <div class="form-group">

            <div fxLayout="column">
                <div class="mgb10">
                    <label>Título (Max 100 caracteres)</label>
                    <input type="text" [(ngModel)]="curso.titulo" value={{curso.titulo}}
                        [ngModelOptions]="{standalone: true}" class="fw" maxlength="200">
                </div>
                <div class="mgb10">
                    <label>Resumen del curso (Max 100 caracteres)</label>
                    <input type="text" [(ngModel)]="curso.resumen" [ngModelOptions]="{standalone: true}" class="fw"
                        maxlength="100">
                </div>
                <div class="mgb10">
                    <label> Foto del Curso </label>
                    <input class="fw" type="file" id="file" (change)="cargarFoto($event, 'foto')" name="image"
                        autocomplete="off" />
                </div>
                <div *ngIf="curso.foto" class="mgt10 mgb10">
                    <div class="containerImg">
                        <img [src]="curso.foto" alt="Imagen del Curso" class="containerImg">
                    </div>
                </div>
                <div fxLayout="row" fxLayoutGap="1rem" class="mgb10">
                    <div class="fw">
                        <label>Precio original (USD)</label>
                        <input type="number" [(ngModel)]="curso.precioOriginal" [ngModelOptions]="{standalone: true}"
                            class="fw">
                    </div>
                    <div class="fw">

                        <label>% de descuento (0-100)</label>
                        <input type="number" [(ngModel)]="curso.porcentajeDescuento"
                            [ngModelOptions]="{standalone: true}" class="fw">
                    </div>
                    <div class="fw">
                        <label>Precio final</label>
                        <input type="number" value={{curso.precioOriginal*(100-curso.porcentajeDescuento)*0.01}}
                            class="fw backGray" readonly>
                    </div>
                    <div class="fw">
                        <label>Porcentaje del instructor</label>
                        <input type="number" [(ngModel)]="curso.instructorPorcentaje"
                            [ngModelOptions]="{standalone: true}" class="fw backGray">
                    </div>
                </div>

                <div fxLayout="row" fxLayoutGap="1rem" class="mgb10">
                    <div class="fw">
                        <label>Categoria</label>
                        <select [(ngModel)]="curso.categoria" [ngModelOptions]="{standalone: true}" class="fw">
                            <option value="null" disabled selected>Seleccione una categoria</option>
                            <option *ngFor="let item of categorias" [ngValue]="item">
                                {{item}}
                            </option>
                        </select>
                    </div>
                    <div class="fw">
                        <label>Idioma</label>
                        <select [(ngModel)]="curso.idioma" [ngModelOptions]="{standalone: true}" class="fw">
                            <option value="Español"> Español</option>
                            <option value="Inglés"> Inglés</option>
                            <option value="Portugués"> Portugués</option>
                        </select>
                    </div>
                    <div  class="fw">
                        <label>Nivel del curso</label>
                        <select [(ngModel)]="curso.nivel" [ngModelOptions]="{standalone: true}" class="fw">
                            <option value="null" disabled selected>Seleccione el nivel del curso</option>
                            <option value="Avanzado">Avanzado</option>
                            <option value="Intermedio">Intermedio</option>
                            <option value="Básico">Básico</option>
                        </select>
                    </div>
                    <div class="fw">
                        <label>Publicado</label>
                        <select [(ngModel)]="curso.publicado" [ngModelOptions]="{standalone: true}" class="fw">
                            <option [ngValue]="true">Publicado</option>
                            <option [ngValue]="false">Borrador</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="mgb10">
                <label>Descripcion curso</label>
                <textarea name="mensaje" class="fw" maxlength="1000" [(ngModel)]="curso.descripcion"
                    [ngModelOptions]="{standalone: true}">
                        </textarea>
            </div>
            <div class="mgb10">
                <label>A quién va dirigido</label>
                <textarea name="mensaje" class="fw" maxlength="1000" [(ngModel)]="curso.dirigidoA"
                    [ngModelOptions]="{standalone: true}">
                        </textarea>
            </div>

            <div class="mgt20">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <h6 class="ft16 ft500 mgt0 mgb0"> Qué aprenderas</h6>
                    <mat-icon (click)="anadirQueAprenderas()" class="mgl10 gray-5 cursorPointer ft20 linkIcon">
                        add_circle</mat-icon>
                </div>
                <hr>

                <div class="fw" *ngFor="let queAprendera of curso.queAprenderas; let i=index">
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="mgt10">
                        <input type="text" [(ngModel)]="curso.queAprenderas[i]" [ngModelOptions]="{standalone: true}"
                            class="fw" fxFlex="95%">
                        <mat-icon class="gray-5 cursorPointer ft20" (click)="eliminarQueAprenderas(i)">
                            delete_outline
                        </mat-icon>
                    </div>
                </div>
            </div>


            <div class="mgt20">
                <div fxLayout="row" fxLayoutAlign=" center">
                    <h6 class="ft16 ft500 mgt0 mgb0"> Adicionales</h6>
                    <mat-icon (click)="anadirAdicionales()" class="mgl10 gray-5 cursorPointer ft20 linkIcon">
                        add_circle</mat-icon>
                </div>
                <hr>

                <div *ngFor="let adicional of curso.adicionales; let i=index">
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="mgt10">
                        <input type="text" [(ngModel)]="curso.adicionales[i]" [ngModelOptions]="{standalone: true}"
                            class="fw" fxFlex="95%">
                        <mat-icon class="gray-5 cursorPointer ft20" (click)="eliminarAdicionales(i)">
                            delete_outline
                        </mat-icon>
                    </div>
                </div>
            </div>




            <h6 class="h6Title">Datos de Instructor</h6>
            <hr>


            <div class="mgb10">
                <label>Instructor</label>
                <select [(ngModel)]="curso.instructorId" [ngModelOptions]="{standalone: true}"
                    (change)="cambioInstructor()" class="fw">
                    <option value="''" disabled selected>Seleccione el Instructor</option>
                    <option *ngFor="let item of instructores; let i=index" [value]="item.id">
                        {{item.nombre}}
                    </option>
                </select>
            </div>
            <div class="mgb10">
                <label>¿Curso dictado por empresa de instructor?</label>
                <select [(ngModel)]="curso.dictaEmpresa" [ngModelOptions]="{standalone: true}" class="fw">
                    <option [ngValue]="true">Si</option>
                    <option [ngValue]="false">No</option>
                </select>
            </div>


            <div *ngIf="instructor" class="mgb10">
                <label>ID de instructor</label>
                <input type="text" value={{curso.instructorId}} class="fw backGray" readonly>
            </div>
            <div *ngIf="instructor" class="mgb10">
                <label>Nombre</label>
                <input type="text" value={{curso.instructorNombre}} class="fw backGray" readonly>
            </div>
            <div *ngIf="instructor" class="mgb10">
                <label>Resumen</label>
                <input type="text" value={{curso.instructorResumen}} class="fw backGray" readonly>
            </div>
            <div *ngIf="instructor" class="mgb10">
                <label>Empresa</label>
                <input type="text" *ngIf="curso.dictaEmpresa == false" value="" class="fw backGray" readonly>
                <input type="text" *ngIf="curso.dictaEmpresa== true" value={{curso.empresaNombre}} class="fw backGray"
                    readonly>
            </div>

            <div *ngIf="curso.instructorFoto" class="containerImg mgt10 mgb10">
                <img *ngIf="curso.instructorFoto" [src]=curso.instructorFoto alt="Imagen del Instructor"
                    class="containerImg">
            </div>
        </div>

    </form>
    <div fxLayout="row" class="mgt10 mgb40">
        <button class="darkButton mgt10" (click)="guardarCurso()">Guardar info de curso</button>
        <button *ngIf="id" class="mgl10 grayButton mgt10 red-5" (click)="onDelete()">Eliminar curso</button>
    </div>

</div>
<div *ngIf="loaded ==0 ">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>